import { useAnimations, useGLTF } from '@react-three/drei';
import { forwardRef, useEffect } from 'react';
import { LoopRepeat } from 'three';

export const Model = forwardRef((props: any, ref) => {
  const { id, glb } = props;
  const url = glb.startsWith('http')
    ? glb
    : 'https://sloydthumbnails.blob.core.windows.net/webapp-mono-assets/web/glbs' + glb;

  const { scene, animations } = useGLTF(url) as any;
  const { actions } = useAnimations(animations, scene);

  useEffect(() => {
    // Enable shadows
    scene.traverse((child: any) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
        child.userData.id = id;
      }
    });
  }, [scene, animations, actions, id]);

  async function runAnimations(actions: any) {
    for (let action of Object.values(actions)) {
      action.setLoop(LoopRepeat, Infinity); // Ensure it loops
      action.reset().play();
      // console.log(action);
      // await delay(1000);
    }
  }

  useEffect(() => {
    if (actions) {
      const action = actions[0] as any;
      runAnimations(actions);

      // Object.values(actions).forEach((action: any) => {
      // console.log('Playing action:', action);
      // action.clampWhenFinished = false; // Prevent stopping after one playthrough
      // action.timeScale = 1; // Ensure normal speed
      // console.log('Animation duration:', action.getClip().duration);

      // action.setLoop(LoopRepeat, Infinity); // Ensure it loops
      // action.reset().fadeIn(0.5).play();
      // });
    }
  }, [actions]);

  return (
    <primitive
      ref={ref}
      position={props.position ?? [0, 0, 0]}
      rotation={props.rotation ?? [0, 0, 0]}
      object={scene}
      scale={props.scale ?? 1}
    />
  );
});
